import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-norm35-step7',
  templateUrl: './norm35-step7.component.html',
  styleUrls: ['./norm35-step7.component.scss']
})
export class Norm35Step7Component implements OnInit {
  dataLink = [
      {
        idLink: "71",
        name  : '7.1 La identificación y análisis de los factores de riesgo psicosocial ',
        ruta : './step7-sub1',
      },{
        idLink: "72",
        name  : '7.2 La identificación y análisis de los factores de riesgo psicosocial deberá contemplar lo siguiente',
        ruta : './step7-sub2',
      },{
        idLink: "73",
        name  : '7.3 La evaluación del entorno organizacional favorable deberá comprender:',
        ruta : './step7-sub3'
      },{
        idLink: "74",
        name  : '7.4 Los centros de trabajo podrán utilizar para identificar y analizar los factores de riesgo psicosocial',
        ruta : './step7-sub4',
      },{
        idLink: "75",
        name  : '7.5 Los cuestionarios que desarrolle el centro de trabajo para la identificación y análisis de los factores de riesgo',
        ruta : './step7-sub5'
      },{
        idLink: "76",
        name  : '7.6 La identificación y análisis de los factores de riesgo psicosocial y la evaluación del entorno organizacional',
        ruta : './step7-sub6'
      },{
        idLink: "77",
        name  : '7.7 El resultado de la identificación y análisis de los factores de riesgo psicosocial',
        ruta : './step7-sub7'
      },{
        idLink: "78",
        name  : '7.8 El resultado de la identificación y análisis de los factores de riesgo psicosocial y la evaluación',
        ruta : './step7-sub8'
      },
    {
      name  : '7.9 La identificación y análisis de los factores de riesgo psicosocial y la evaluación del entorno organizacional ',
      ruta : './step7-sub9'
    }
  ]

  dataSubLink = [
    {
      idSubLink: "71",
      name  : '7.1 La identificación y análisis de los factores de riesgo psicosocial ',
      ruta : './step7-sub1'
    },{
      idSubLink: "71",
      name  : '7.1 a) Los centros de trabajo que tengan entre 16 y 50 trabajadores ',
      ruta : './step7-sub1-a%29'
    },{
      idSubLink: "71",
      name  : '7.1 b)  Los centros de trabajo que tengan más de 50 trabajadores ',
      ruta : './step7-sub1-b%29'
    },{
      idSubLink: "72",
      name : '7.2 a) Las condiciones en el ambiente de trabajo',
      ruta:'./step7-sub2-a%29'
    },{
      idSubLink: "74",
      name  : '7.4 a) La aplicación de cuestionarios que cumplan con lo dispuesto por los numerales 7.2 y/o 7.3',
      ruta : './step7-sub4-a%29'
    },{
      idSubLink: "74",
      name  : '7.4 b) La forma como se deberá realizar la aplicación de los cuestionarios',
      ruta : './step7-sub4-b%29'
    },{
      idSubLink: "74",
      name  : '7.4 c) La manera de evaluar los cuestionarios',
      ruta : './step7-sub4-c%29'
    },{
      idSubLink: "74",
      name  : '7.4 d) Los niveles de riesgo y la forma de determinarlos conforme a los resultados de los cuestionarios',
      ruta : './step7-sub4-d%29'
    }
  
  ]
  constructor() { }

  ngOnInit() {
  }

}
